import {TopBanner} from '@/components/main/MyPlus/common/TopBanner';
import {useEffect, useState} from 'react';

const MainListBnContentType = ({data}) => {
  const [itemList, setItemList] = useState([]);

  useEffect(() => {
    if (data) {
      setItemList({
        mainListTopBnrData: [...data],
        mainListTopBnrResult: 1,
      });
    }
  }, [data]);

  return (
    <section className={'popular-wrapper'}>
      <TopBanner mainListInfo={itemList} />
      <div className={'divider'} />
    </section>
  );
};
export default MainListBnContentType;
